import { Component, inject, OnInit } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet],
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Fonction pour scroll to top avec support Safari iOS
        const scrollToTop = () => {
          // Détecter Safari iOS
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

          // Méthode 1: window.scrollTo avec options
          if (window.scrollTo) {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant" as ScrollBehavior,
            });
            // Fallback pour Safari
            window.scrollTo(0, 0);
          }

          // Méthode 2: document.documentElement
          if (document.documentElement) {
            document.documentElement.scrollTop = 0;
          }

          // Méthode 3: document.body (important pour Safari)
          if (document.body) {
            document.body.scrollTop = 0;
          }

          // Méthode 4: document.scrollingElement (pour iOS Safari)
          if (document.scrollingElement) {
            document.scrollingElement.scrollTop = 0;
          }

          // Méthode 5: Spécifique Safari iOS - forcer le scroll
          if (isIOS && window.pageYOffset !== undefined) {
            window.scrollTo(0, 0);
            // Forcer plusieurs fois pour Safari
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        };

        // Exécuter immédiatement
        scrollToTop();

        // Exécuter après un court délai
        setTimeout(() => {
          scrollToTop();
        }, 0);

        // Exécuter après requestAnimationFrame
        requestAnimationFrame(() => {
          scrollToTop();
        });

        // Exécuter après un délai plus long (pour Safari qui a besoin de plus de temps)
        setTimeout(() => {
          scrollToTop();
        }, 100);

        // Double requestAnimationFrame pour Safari
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToTop();
          });
        });
      });
  }
}
